import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioTravelDateEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioTravelDateEntity
